<template>
    <div class="common-seach-wrap">
        <!--活动列表-->
        <List v-if="activeName == 'activity'"></List>
        <!--合作伙伴-->
<!--        <Cooperate v-if="activeName == 'cooperate'"></Cooperate>-->
        <!--活动订单-->
        <Order v-if="activeName == 'order'"></Order>
        <!--健康币-->
        <Coin v-if="activeName == 'coin'"></Coin>
        <!--商品列表-->
        <Goodslist v-if="activeName == 'goodslist'"></Goodslist>
    </div>
</template>
<script>
    import bus from "@/utils/eventBus.js";
    import List from "./activity/index";
    // import Cooperate from "./cooperate/index";
    import Order from "./order/index";
    import Coin from "./coin/index";
    import Goodslist from "./goods/list";
    export default {
        components: {
            List,
            // Cooperate,
            Order,
            Coin,
            Goodslist
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                form: {},
                /*参数*/
                param: {},
                /*当前选中*/
                activeName: "activity",
                /*切换数组原始数据*/
                sourceList: [
                    {
                        key: "activity",
                        value: "活动列表",
                        path: "/platformactivity/activity/index"
                    },
                    // {
                    //     key: "cooperate",
                    //     value: "合作意向",
                    //     path: "/platformactivity/cooperate/index"
                    // },
                    {
                        key: "order",
                        value: "活动订单",
                        path: "/platformactivity/order/index"
                    },
                    {
                        key: "coin",
                        value: "健康币",
                        path: "/platformactivity/coin/index"
                    },
                    {
                        key: "goodslist",
                        value: "商品列表",
                        path: "/platformactivity/goods/list"
                    }
                ],
                /*权限筛选后的数据*/
                tabList: []
            };
        },
        mounted() {
            this.tabList = this.authFilter();
            if (this.tabList.length > 0) {
                this.activeName = this.tabList[0].key;
            }

            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }

            /*监听传插件的值*/
            bus.$on("activeValue", (res) => {
                this.activeName = res;
            });

            //发送类别切换
            let params = {
                active: this.activeName,
                list: this.tabList,
                tab_type: "activity"
            };
            bus.$emit("tabData", params);
        },
        beforeDestroy() {
            //发送类别切换
            bus.$emit("tabData", { active: null, tab_type: "activity", list: [] });
            bus.$off("activeValue");
        },
        methods: {
            /*权限过滤*/
            authFilter() {
                let list = [];
                for (let i = 0; i < this.sourceList.length; i++) {
                    let item = this.sourceList[i];
                    if (this.$filter.isAuth(item.path)) {
                        list.push(item);
                    }
                }
                return list;
            }
        }
    };
</script>

<style>
    .operation-wrap {
        height: 124px;
        border-radius: 8px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 30px 30px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: hidden;
        background: #909399;
        background-size: 100% 100%;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/index.vue